/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_weekdays_wednesday = /** @type {(inputs: {}) => string} */ () => {
	return `Středa`
};

const da_weekdays_wednesday = /** @type {(inputs: {}) => string} */ () => {
	return `Onsdag`
};

const de_weekdays_wednesday = /** @type {(inputs: {}) => string} */ () => {
	return `Mittwoch`
};

const en_weekdays_wednesday = /** @type {(inputs: {}) => string} */ () => {
	return `Wednesday`
};

const es_weekdays_wednesday = /** @type {(inputs: {}) => string} */ () => {
	return `Miércoles`
};

const fr_weekdays_wednesday = /** @type {(inputs: {}) => string} */ () => {
	return `Mercredi`
};

const hu_weekdays_wednesday = /** @type {(inputs: {}) => string} */ () => {
	return `Szerda`
};

const it_weekdays_wednesday = /** @type {(inputs: {}) => string} */ () => {
	return `Mercoledì`
};

const nl_weekdays_wednesday = /** @type {(inputs: {}) => string} */ () => {
	return `Woensdag`
};

const pl_weekdays_wednesday = /** @type {(inputs: {}) => string} */ () => {
	return `Środa`
};

const pt_weekdays_wednesday = /** @type {(inputs: {}) => string} */ () => {
	return `Quarta-feira`
};

const sv_weekdays_wednesday = /** @type {(inputs: {}) => string} */ () => {
	return `Onsdag`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const weekdays_wednesday = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.weekdays_wednesday(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("weekdays_wednesday", locale)
	if (locale === "cs") return cs_weekdays_wednesday(inputs)
	if (locale === "da") return da_weekdays_wednesday(inputs)
	if (locale === "de") return de_weekdays_wednesday(inputs)
	if (locale === "en") return en_weekdays_wednesday(inputs)
	if (locale === "es") return es_weekdays_wednesday(inputs)
	if (locale === "fr") return fr_weekdays_wednesday(inputs)
	if (locale === "hu") return hu_weekdays_wednesday(inputs)
	if (locale === "it") return it_weekdays_wednesday(inputs)
	if (locale === "nl") return nl_weekdays_wednesday(inputs)
	if (locale === "pl") return pl_weekdays_wednesday(inputs)
	if (locale === "pt") return pt_weekdays_wednesday(inputs)
	return sv_weekdays_wednesday(inputs)
};
export { weekdays_wednesday as "weekdays.wednesday" }